import Header from "./Header";
import Footer from "./Footer";

const NotFound = () => {
  return (
    <>
      <Header />

      <main className="not-found">
        <div className="not-found-content">
          <p className="not-found-code">Page Not Found</p>

          <h1>404</h1>

          <p>
            Sorry, the page you're looking for doesn't exist.
          </p>

          <a href="/" className="not-found-button">
            Go Back Home
          </a>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default NotFound;
